import { Select, MenuItem, Divider, SelectChangeEvent, InputLabel } from '@unity/cloud-ui';
import { useTranslations } from 'next-intl';
import { usePathname, useRouter } from 'next/navigation';
import { manifestSchema } from '@/lib/content-loader/schemas/manifest.schema';

export type AvailableVersions = manifestSchema[string]['versions'];

export const VersionPicker = (props: { versions: AvailableVersions }) => {
  const t = useTranslations();
  const pathname = usePathname();
  const router = useRouter();

  if (props.versions.length === 0) {
    return null;
  }

  const selectedVersion =
    props.versions.find((version) => pathname.toLowerCase().includes(version.path.toLowerCase())) ?? props.versions[0];

  const handleVersionChange = (event: SelectChangeEvent<string>) => {
    const newVersion = props.versions.find((version) => version.title === event.target.value);
    if (newVersion) {
      const cleanedPathname = pathname.replace(new RegExp(`^.*${selectedVersion.path}`), '');
      router.push(`${newVersion.path}${cleanedPathname}`);
    }
  };

  return (
    <>
      <InputLabel id="version-picker-label">{t('sidebar:section:version')}</InputLabel>
      <Select
        value={selectedVersion.title}
        size="small"
        aria-label={t('feedback:select:aria-label')}
        labelId="version-picker-label"
        MenuProps={{
          disableScrollLock: true,
          sx: {
            '&& .Mui-selected': {
              bgcolor: (theme) => `${theme.vars.palette.primary.light} !important`,
              '&:hover': { bgcolor: 'primary.light' },
            },
            '&& .MuiMenu-list': {
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
            },
          },
        }}
        onChange={handleVersionChange}
      >
        {props.versions.map((version) => {
          return (
            <MenuItem key={version.path} value={version.title}>
              {version.title}
            </MenuItem>
          );
        })}
      </Select>
      <Divider />
    </>
  );
};
